// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"284f02ee","453":"51b20bab","455":"d87dbadd"}[chunkId] + ".chunk.js";
};